import { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle<{ use: boolean }>`
  ${(props) =>
    !props.use &&
    css`
      @media print {
        html,
        body {
          display: none !important;
        }
      }
    `}
`;
